module.exports = __webpack_public_path__ + "assets/beed0145db82f69a3292dc908e116322.mp3";